import { render } from "./RightSidebar.vue?vue&type=template&id=4867da38&scoped=true"
import script from "./RightSidebar.vue?vue&type=script&lang=js"
export * from "./RightSidebar.vue?vue&type=script&lang=js"

import "./RightSidebar.vue?vue&type=style&index=0&id=4867da38&lang=css"
import "./RightSidebar.vue?vue&type=style&index=1&id=4867da38&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4867da38"

export default script